
class Keys {
  static sidebarStatusKey = 'sidebarStatusKey'
  static languageKey = 'languageKey'
  static sizeKey = 'sizeKey'
  static tokenKey = 'access-token'
  static aseKey = 'ase-key'
  static rememberKey='remember-key'
}

export default Keys
